// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"668c8af5","732":"6aa27b24"}[chunkId] + ".chunk.js";
};